

// A RTCSessionDescription like object exposed for native WebRTC compatability
module.exports = function RTCSessionDescription(options) {
  this.type = options.type;
  this.sdp = options.sdp;
};



// WEBPACK FOOTER //
// ./src/js/otplugin/rtc/rtc_session_description.js